import { useEffect, useState } from "react";
import { Box, Button, Grid, Switch, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import SnackBar from "../../../../../components/snackbar/SnackBar";
import { GetSettings } from "../usecases/GetSettings";
import { UpdateSettings } from "../usecases/UpdateSettings";

const DriverNotificationsCard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [notificationDriver, setNotificationDriver] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageSnk, setMessageSnk] = useState("");
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");

  const vertical = "top";
  const horizontal = "center";

  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severityValue = "success") => {
    setMessageSnk(message);
    setSeverity(severityValue);
    setStateSnk(true);
  };

  useEffect(() => {
    const getSettings = async () => {
      setLoading(true);
      const resp = await GetSettings();
      if (resp.message === "ok") {
        setNotificationDriver(Boolean(resp.data.notification_driver));
      } else {
        snackBarDialog("ERROR AL CARGAR CONFIGURACION", "error");
      }
      setLoading(false);
    };

    getSettings();
  }, []);

  const handleUpdate = async (event) => {
    event.preventDefault();
    setLoading(true);
    const resp = await UpdateSettings({
      notification_driver: notificationDriver,
    });

    if (resp.message === "ok") {
      setNotificationDriver(Boolean(resp.data.notification_driver));
      snackBarDialog("CONFIGURACION ACTUALIZADA");
    } else {
      snackBarDialog("ERROR DE ACTUALIZACION", "error");
    }
    setLoading(false);
  };

  return (
    <Box backgroundColor={colors.primary[400]} p={2} mb={1}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography variant="h4">Notificaciones para Driver</Typography>
        </Grid>
        <Grid item xs={6} sm={4} textAlign="center">
          <Switch
            checked={notificationDriver}
            onChange={(event) => setNotificationDriver(event.target.checked)}
            color="secondary"
            disabled={loading}
            inputProps={{ "aria-label": "notificaciones para driver" }}
          />
        </Grid>
        <Grid item xs={6} sm={2}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            sx={{
              height: 40,
              color: "#fff",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            onClick={handleUpdate}
            disabled={loading}
          >
            ACTUALIZAR
          </Button>
        </Grid>
      </Grid>
      <SnackBar
        stateSnk={stateSnk}
        vertical={vertical}
        horizontal={horizontal}
        duration={4000}
        handleClose={handleSnkClose}
        severity={severity}
        messageSnk={messageSnk}
      />
    </Box>
  );
};

export default DriverNotificationsCard;
